import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NGFontAwesomeModule } from '../global/ngfontawesome.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PrimengModule } from '../global/primeng.module';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { PropertyModule } from '../property/property.module';
import { WizardModule } from '../shared/wizard/wizard.module';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { FieldsetModule } from 'primeng/fieldset';
import { ManagePartnershipComponent } from './manage-partnership/manage-partnership.component';
import { PartnershipListComponent } from './manage-partnership/partnership-list/partnership-list.component';
import { EditPartnershipComponent } from './manage-partnership/edit-partnership/edit-partnership.component';
import { AddPartnershipComponent } from './manage-partnership/add-partnership/add-partnership.component';

import { PartnershipDetailComponent } from './manage-partnership/partnership-detail/partnership-detail.component';
import { PartnerDetailComponent } from './manage-partnership/partner-detail/partner-detail.component';
import { ManagePartnerUserComponent } from './manage-partner-user/manage-partner-user.component';
import { PicklistAssetGroupComponent } from './picklist-asset-group/picklist-asset-group.component';
import { PartnerUserListComponent } from './manage-partner-user/partner-user-list/partner-user-list.component';
import { AddPartnerUserComponent } from './manage-partner-user/add-partner-user/add-partner-user.component';
import { EditPartnerUserComponent } from './manage-partner-user/edit-partner-user/edit-partner-user.component';
import { ManageUserRelationshipComponent } from './manage-user-relationship/manage-user-relationship.component';
import { AddUserComponent } from './manage-user-relationship/add-user/add-user.component';
import { EditUserComponent } from './manage-user-relationship/edit-user/edit-user.component';
import { PartnerService } from './partner-service';
import { PartnerUserService } from './partner-user.service';
import { PartnershipService } from './partnership.service';
import { PartnershipDropdownComponent } from './partnership-dropdown/partnership-dropdown.component';
import { AssetGroupDropdownComponent } from './asset-group-dropdown/asset-group-dropdown.component';
import { AssetIdDropdownComponent } from './asset-id-dropdown/asset-id-dropdown.component';
import { UserRelationshipService } from './user-relationship.service';
import { ManageAssetGroupComponent } from './manage-asset-group/manage-asset-group.component';
import { AddAssetGroupComponent } from './manage-asset-group/add-asset-group/add-asset-group.component';
import { EditAssetGroupComponent } from './manage-asset-group/edit-asset-group/edit-asset-group.component';
import { SharedModule } from '../shared';
import { PersonModule } from '../person/person.module';
import { PrivilegeDropdownComponent } from './privilege-dropdown/privilege-dropdown.component';
import { AddUserAccessComponent } from './manage-user-relationship/add-user-access/add-user-access.component';
import { EditUserAccessComponent } from './manage-user-relationship/edit-user-access/edit-user-access.component';
import { ManageUserGroupComponent } from './manage-user-group/manage-user-group.component';
import { ListUserGroupComponent } from './manage-user-group/list-user-group/list-user-group.component';
import { AddUserGroupComponent } from './manage-user-group/add-user-group/add-user-group.component';
import { EditUserGroupComponent } from './manage-user-group/edit-user-group/edit-user-group.component';
import { PrivilegeGroupDropdownComponent } from './privilege-group-dropdown/privilege-group-dropdown.component';
import { ChangePrimaryContactComponent } from './change-primary-contact/change-primary-contact.component';
import { InactivateUserComponent } from './manage-user-relationship/inactivate-user/inactivate-user.component';
import { InactivatePartnerUserComponent } from './manage-partner-user/inactivate-partner-user/inactivate-partner-user.component';

@NgModule({
  declarations: [
    ManagePartnershipComponent,
    AddPartnershipComponent,
    PartnershipListComponent,
    EditPartnershipComponent,
    PartnershipDetailComponent,
    ManagePartnerUserComponent,
    AddPartnerUserComponent,
    EditPartnerUserComponent,
    PartnerDetailComponent,
    PicklistAssetGroupComponent,
    PartnerUserListComponent,
    ManageUserRelationshipComponent,
    AddUserComponent,
    EditUserComponent,
    PartnershipDropdownComponent,
    AssetGroupDropdownComponent,
    AssetIdDropdownComponent,
    ManageAssetGroupComponent,
    AddAssetGroupComponent,
    EditAssetGroupComponent,
    PrivilegeDropdownComponent,
    AddUserAccessComponent,
    EditUserAccessComponent,
    ManageUserGroupComponent,
    ListUserGroupComponent,
    AddUserGroupComponent,
    EditUserGroupComponent,
	  PrivilegeGroupDropdownComponent,
	  ChangePrimaryContactComponent,
	  InactivateUserComponent,
	  InactivatePartnerUserComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NGFontAwesomeModule,
    FontAwesomeModule,
    PrimengModule,
    FormsModule,
    CoreModule,
    PropertyModule,
    SharedModule,
    ReactiveFormsModule,
    WizardModule,
    PersonModule,
    BreadcrumbModule,
    FieldsetModule
  ],
  exports: [
    ManagePartnershipComponent,
    AddPartnershipComponent,
    PartnershipListComponent,
    EditPartnershipComponent,
    PartnershipDetailComponent,
    ManagePartnerUserComponent,
    AddPartnerUserComponent,
    EditPartnerUserComponent,
    PartnerDetailComponent,
    PicklistAssetGroupComponent,
    PartnerUserListComponent,
    ManageUserRelationshipComponent,
    AddUserComponent,
    EditUserComponent,
    PartnershipDropdownComponent,
    AssetGroupDropdownComponent,
    AssetIdDropdownComponent,
    ManageAssetGroupComponent,
    AddAssetGroupComponent,
    EditAssetGroupComponent,
    ManageUserGroupComponent,
    ListUserGroupComponent,
    AddUserGroupComponent,
    EditUserGroupComponent,
	  PrivilegeGroupDropdownComponent
  ],
  entryComponents: [
    ManageUserRelationshipComponent,
    ManagePartnershipComponent,
    PartnershipDetailComponent,
    ManageAssetGroupComponent
  ],
  providers: [
    PartnerService,
    PartnerUserService,
    PartnershipService,
    UserRelationshipService
  ],
})
export class PartnershipModule { }
